<template>
  <span>
    <div v-show="exibirListaEntidades" class="p-fluid formgrid grid">
      <div class="field col-6 md:col-6">
        <label for="entidade">Entidade</label>
        <MultiSelect
          id="entidade"
          v-model="v$.entidadesSelecionadas.$model"
          :class="{
            'p-invalid': submitted && v$.entidadesSelecionadas.$invalid,
          }"
          optionLabel="nome"
          :options="entidades"
          :filter="true"
          filterPlaceholder="Procure pelo nome da entidade"
          :emptyFilterMessage="'Nenhuma entidade encontrada'"
          placeholder="Selecione uma entidade"
          display="chip"
          @input="adicionarEntidade">
        </MultiSelect>
        <div
          v-if="submitted && v$.entidadesSelecionadas.required.$invalid"
          class="p-error">
          O campo Entidade é obrigatório.
        </div>
      </div>
      <div v-show="exibirListaConsignataria" class="field col-6 md:col-6">
        <label for="consignataria">Consignatária</label>
        <MultiSelect
          id="consignataria"
          v-model="v$.consignatariasSelecionadas.$model"
          :class="{
            'p-invalid': submitted && v$.consignatariasSelecionadas.$invalid,
          }"
          dataKey="id"
          :disabled="habilitarCampoConsignataria"
          optionLabel="cnpjRazaoSocial"
          :options="concatenarCnpjRazaoSocial"
          :filter="true"
          filterPlaceholder="Procure pelo nome da consignataria"
          :emptyFilterMessage="'Nenhuma consignataria encontrada'"
          placeholder="Selecione uma consignataria"
          display="chip"
          @input="adicionarConsignataria">
        </MultiSelect>
        <div
          v-if="submitted && v$.consignatariasSelecionadas.required.$invalid"
          class="p-error">
          O campo Consignataria é obrigatório.
        </div>
      </div>
    </div>
    <div class="p-fluid formgrid grid">
      <div class="field col-6 md:col-6">
        <label for="dataEntidade">Data de Referência</label>
        <Calendar
          v-model="v$.dataReferencia.$model"
          :class="{
            'p-invalid': submitted && v$.dataReferencia.$invalid,
          }"
          view="month"
          dateFormat="mm/yy"
          @input="adicionarMesEAnoReferencia" />
        <div
          v-if="submitted && v$.dataReferencia.required.$invalid"
          class="p-error">
          O campo Data de Referência é obrigatório.
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import UseVuelidate from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'
import ConsignatariaService from '@/service/ConsignatariaService.js'
import EntidadeService from '@/service/EntidadeService.js'
import { consignatariaStore } from '@/stores/consignataria'
import ServidorService from '@/service/ServidorService'

export default {
  name: 'LayoutFiltro06',

  props: {
    submitted: {
      type: Boolean,
      default: false,
    },
    modulo: {
      type: String,
      required: true,
    },
  },

  setup() {
    const store = consignatariaStore()
    return { v$: UseVuelidate(), store }
  },

  data() {
    return {
      entidades: [],
      entidadesSelecionadas: [],
      entidadesIdSelecionados: [],
      consignatarias: [],
      consignatariasSelecionadas: [],
      consignatariasIdSelecionados: [],
      dataReferencia: null,
      mesReferencia: null,
      anoReferencia: null,
      exibirListaEntidades: false,
      exibirListaConsignataria: false,
      parametros: new Map(),
    }
  },

  computed: {
    habilitarCampoConsignataria() {
      return this.store.consignatariaSelecionada !== null
    },

    concatenarCnpjRazaoSocial() {
      return this.consignatarias.map((consignataria) => ({
        ...consignataria,
        cnpjRazaoSocial: consignataria.cnpj + ' | ' + consignataria.razaoSocial,
      }))
    },
  },

  validations() {
    return {
      dataReferencia: { required },
      entidadesSelecionadas: { required },
      consignatariasSelecionadas: {
        required: requiredIf(this.modulo === 'gestao'),
      },
    }
  },

  created() {
    this.consignatariaService = new ConsignatariaService(this.$http)
    this.entidadeService = new EntidadeService(this.$http)
    this.servidorService = new ServidorService(this.$http)
    this.adicionarConsignatariaPreviamente()
  },

  mounted() {
    this.carregarEntidade()
    this.carregarConsignataria()
  },

  methods: {
    carregarEntidade() {
      this.carregarListaEntidades() //Vai estar implementado no componente filho
      this.exibirListaEntidades = true
    },

    carregarConsignataria() {
      this.carregarListaConsignatarias() //Vai estar implementado no componente filho
      this.exibirListaConsignataria = true
    },

    validate() {
      this.v$.dataReferencia.$touch()
      this.v$.entidadesSelecionadas.$touch()
      this.v$.consignatariasSelecionadas.$touch()

      return !(
        this.v$.dataReferencia.$invalid ||
        this.v$.entidadesSelecionadas.$invalid ||
        this.v$.consignatariasSelecionadas.$invalid
      )
    },

    adicionarEntidade() {
      this.adicionarListaIds('entidade')
      this.parametros.set('entidadeId', this.entidadesIdSelecionados)
      this.$emit('parametros', this.parametros)
      this.entidadesIdSelecionados = []
    },

    adicionarConsignataria() {
      this.adicionarListaIds('consignataria')
      this.parametros.set('consignatariaId', this.consignatariasIdSelecionados)
      this.$emit('parametros', this.parametros)
      this.consignatariasIdSelecionados = []
    },

    adicionarListaIds(tipo) {
      if (tipo == 'entidade') {
        this.entidadesSelecionadas.forEach((valor) =>
          this.entidadesIdSelecionados.push(valor.id.toString()),
        )
      } else if (tipo == 'consignataria') {
        this.consignatariasSelecionadas.forEach((valor) =>
          this.consignatariasIdSelecionados.push(valor.id.toString()),
        )
      }
    },

    adicionarMesEAnoReferencia() {
      this.mesReferencia = (this.dataReferencia.getMonth() + 1).toString()
      this.anoReferencia = `${this.dataReferencia.getFullYear()}`
      this.parametros.set('mesReferencia', this.mesReferencia)
      this.parametros.set('anoReferencia', this.anoReferencia)
      this.$emit('parametros', this.parametros)
    },

    limpar() {
      this.entidadesSelecionadas = []
      this.entidadesIdSelecionados = []
      this.consignatariasSelecionadas = []
      this.consignatariasIdSelecionados = []
      this.dataReferencia = ''
      this.mesReferencia = ''
      this.anoReferencia = ''
    },

    adicionarConsignatariaPreviamente() {
      if (
        this.store.consignatariaSelecionada &&
        !this.parametros.get('consignatariaId')
      ) {
        this.parametros.set(
          'consignatariaId',
          this.store.consignatariaSelecionada.id.toString(),
        )
        this.$emit('parametros', this.parametros)
      }
    },

    usuarioTemPermissaoDeGestao() {
      return (
        this.$auth.hasRoleGestao() ||
        this.$auth.hasRoleGestaoAdmin() ||
        this.$auth.hasRoleGestaoEntidade() ||
        this.$auth.hasRoleGestaoFinanceira()
      )
    },

    usuarioTemPermissaoDeConsignataria() {
      return (
        this.$auth.hasRoleConsignatariaUser() ||
        this.$auth.hasRoleConsignatariaAdmin()
      )
    },

    usuarioTemPermissaoDeServidor() {
      return this.$auth.hasRoleServidor()
    },

    usuarioTemApenasPermissaoDeServidor() {
      return (
        !this.usuarioTemPermissaoDeGestao() &&
        !this.usuarioTemPermissaoDeConsignataria() &&
        this.usuarioTemPermissaoDeServidor()
      )
    },
  },
}
</script>
